import { Button, Flex, Text, Title, rem, useMantineTheme } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { RoutePaths } from "@/core/constants/RoutePaths";
import EmailVerifiedIcon from "@/shared/components/@Icons/EmailVerifiedIcon";
import AccountFlowLayout from "@/shared/components/AccountFlowLayout";

export default function EmailVerifiedPage() {
  const theme = useMantineTheme();
  const navigate = useNavigate();

  const handleConfigureAccount = () => {
    navigate(RoutePaths.LOGIN);
  };

  return (
    <AccountFlowLayout>
      <Flex
        direction={"column"}
        align="center"
        maw={rem(640)}
        w={"100%"}
        style={{
          flexGrow: 1,
        }}>
        <Flex
          direction="column"
          align="center"
          gap={rem(24)}
          style={{ flexGrow: 1 }}
          justify="start">
          <EmailVerifiedIcon
            color={theme.colors["R300"][0]}
            opacity={0.7}
          />

          <div>
            <Title
              order={2}
              ta="center"
              mb={rem(12)}
              c={theme.colors["plain_text"][0]}>
              Seu e-mail{" "}
              <span style={{ color: theme.colors["R300"][0] }}>
                foi verificado!
              </span>
            </Title>
            <Text
              ta="center"
              fz={rem(16)}
              c={theme.colors["L750"][0]}>
              Clique no botão abaixo para fazer login e acessar sua conta.
            </Text>
          </div>

          <Button
            fullWidth
            mt={rem(24)}
            size="md"
            radius={rem(8)}
            bg={theme.colors["contrast_text"][0]}
            ff={"Outfit, sans-serif"}
            onClick={handleConfigureAccount}>
            Acessar conta
          </Button>
        </Flex>
      </Flex>
    </AccountFlowLayout>
  );
}
